import _                from 'lodash';
import ReactHtmlParser  from 'react-html-parser';

import bbCode           from './buildLang';

// Langue files
import fr from '../lang/fr.json';

const getMessage = (label, lang = fr, plainObject = false) => {
  const lng = lang;
  let obj = _.get(lng, label);

  if (plainObject) {
    return obj;
  }

  if (typeof obj === 'object') {
    const newObj = {};
    _.forIn(obj, (v,k) => {
      const value = v ? bbCode(v) : v;
      newObj[k] = ReactHtmlParser(value);
    });
    obj = newObj;
  }
  else {
    const value = obj ? bbCode(obj) : obj;
    obj = ReactHtmlParser(value);
  }

  return obj;
};

export default getMessage;



// WEBPACK FOOTER //
// ./src/global/getMessage.js